import * as React from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'

import './index.styles.css'

export interface Row {
  id: string
  value?: number
  description?: string
}

interface Props {
  row: Row
  onUpdateRow: (row: Row) => void
}

const TaxRateRow: React.FC<Props> = ({ row, onUpdateRow }) => {
  const updateValue = (e: string) => {
    if (e === '' || e === '-') {
      onUpdateRow({ ...row, value: undefined })
    } else {
      onUpdateRow({ ...row, value: parseFloat(e) })
    }
  }

  const updateDescription = (e: string) => {
    onUpdateRow({ ...row, description: e })
  }

  const invalidPercentage = (row.value || 0) > 100 || (row.value || 0) < -100

  return (
    <>
      <Table.Cell padding="s0" wide>
        <Box
          className={
            `${'TaxRateRow_borderlessInput'}` +
            `${invalidPercentage ? ` ${'TaxRateRow_errorBorderlessInput'}` : ''}`
          }
        >
          <TextField
            hideBorder
            type="number"
            min={-100}
            step={'0.01'}
            value={row.value?.toString() || ''}
            isNotValid={invalidPercentage}
            onChange={updateValue}
            hideError
          />
        </Box>
      </Table.Cell>
      <Table.Cell padding="s0" wide>
        <Box
          justifyContent="center"
          height="full"
          border={{
            left: {
              width: 's1',
              style: 'solid',
              color: 'darker160',
            },
          }}
        >
          <TextField
            hideBorder
            type="text"
            value={row.description || ''}
            onChange={updateDescription}
          />
        </Box>
      </Table.Cell>
    </>
  )
}

export default TaxRateRow
